import { User } from '../types/user.types';

export const isUserFollowing = (user: User, userId: number) => {
  if (!user) {
    return false;
  }
  return !!user.following.find(({ id }) => userId === id);
};
